import { clamp } from './fieldGeometry'

export const ARRIVAL_DURATION = 2700
export function smoothCurve(value: number) {
  const t = clamp(value)
  return t * t * t * (t * (t * 6 - 15) + 10)
}
export function arrivalReveal(elapsed: number) { return clamp(elapsed / 180) }
function arc(start: number, control: number, end: number, t: number) {
  return (1 - t) ** 2 * start + 2 * (1 - t) * t * control + t * t * end
}
export function arrivalLogoFrame(elapsed: number, width: number, height: number, size: number, headerTop: number, mobile: boolean) {
  const x = (width - size) / 2, y = (height - size) / 2
  const enter = clamp(elapsed / 720)
  const eased = 1 - (1 - enter) ** 4
  const overshoot = Math.sin(Math.PI * enter) * .24
  const move = smoothCurve((elapsed - 1650) / (ARRIVAL_DURATION - 1650))
  const destinationX = mobile ? 22 : x
  return {
    opacity: arrivalReveal(elapsed),
    x: move > 0 ? arc(x, x + Math.min(width * .16, 120), destinationX, move) : arc(x + 32, x - 26, x, eased),
    y: move > 0 ? arc(y, y * .24, headerTop, move) : arc(y + 36, y + 26, y, eased),
    scale: move > 0 ? 2 - move : .35 + 1.65 * eased + overshoot,
    rotation: move > 0 ? Math.sin(move * Math.PI) * -5 : -14 * (1 - eased),
  }
}
